import type { ReactElement, SyntheticEvent } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import ToggleSwitchAtm from "@onestore/hel/dist/components/atoms/ToggleSwitchAtm"
import AlignContentOrg from "@onestore/hel/dist/components/organisms/AlignContentOrg"
import WrapOrg from "@onestore/hel/dist/components/organisms/WrapOrg"

interface LabeledToggleSwitchProps {
  onClick: { (event: SyntheticEvent<HTMLInputElement>): void }
  isChecked: boolean
  label: string
  id: string
}

export default function LabeledToggleSwitch({
  onClick,
  isChecked,
  label,
  id,
}: LabeledToggleSwitchProps): ReactElement<LabeledToggleSwitchProps> {
  return (
    <AlignContentOrg horizontalAlign="right">
      <WrapOrg gutterSpace={2} alignCenter="vertical">
        <TextAtm typography="small4">{label}</TextAtm>
        <ToggleSwitchAtm onClick={onClick} id={id} isChecked={isChecked} />
      </WrapOrg>
    </AlignContentOrg>
  )
}
